module.exports = __webpack_public_path__ + "h5/img/statis1.96f33330.png";